import { getDisplayedValue } from 'customer-data-property-utils/PropertyValueDisplay';
import { decoratorColorToTrellisTokenMap } from 'customer-data-property-utils/optionDecoratorUtils';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { StatusDot } from 'foundations-components/transitional/components/StatusDot';
import useOptionColors, { decoratorColorToBadgeMap } from '../../input/select/useOptionColors';
import useComponentMountMetric from '../../metrics/useComponentMountMetric';
import { useGetIsUngated } from '../hooks/useGetIsUngated';
import { gate } from 'hub-http/gates';
import AutolinkedText from './AutolinkedText';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FormattedPropertyDisplayedValue = ({
  property,
  propertyValue,
  dateFormat,
  dateTimeFormat,
  enableAutolinking,
  relativeDate,
  relativeDateTime,
  objectTypeId,
  placeholder,
  dataAttributes
}) => {
  useComponentMountMetric('FormattedPropertyDisplayedValue');
  const getIsUngated = useGetIsUngated();
  const {
    colorByOptionValue,
    shouldUseOptionColors,
    shouldUseBadgeDisplay
  } = useOptionColors();
  const displayedValue = getDisplayedValue(property, propertyValue, undefined, {
    dateFormat,
    dateTimeFormat,
    relativeDate,
    relativeDateTime,
    showDateDisplayHintLabel: true
  }, objectTypeId) || placeholder;
  if (shouldUseBadgeDisplay && propertyValue) {
    var _colorByOptionValue$S;
    const badgeColor = ((_colorByOptionValue$S = colorByOptionValue[String(propertyValue)]) === null || _colorByOptionValue$S === void 0 ? void 0 : _colorByOptionValue$S.badgeColor) || decoratorColorToBadgeMap.GRAY;
    return /*#__PURE__*/_jsx("span", Object.assign({}, dataAttributes, {
      children: /*#__PURE__*/_jsx(Badge, {
        use: badgeColor,
        "data-test-badge-use": badgeColor,
        "data-test-id": "badge",
        children: displayedValue
      })
    }));
  }
  if (shouldUseOptionColors && propertyValue) {
    var _colorByOptionValue$S2;
    const statusDotColor = ((_colorByOptionValue$S2 = colorByOptionValue[String(propertyValue)]) === null || _colorByOptionValue$S2 === void 0 ? void 0 : _colorByOptionValue$S2.trellisColor) || decoratorColorToTrellisTokenMap.GRAY;
    return /*#__PURE__*/_jsxs("span", Object.assign({}, dataAttributes, {
      children: [/*#__PURE__*/_jsx(StatusDot, {
        role: "status",
        color: statusDotColor,
        "data-test-color": statusDotColor
      }), displayedValue]
    }));
  }
  const hasLinkifyAllPropertiesAccess = getIsUngated(gate('CRM:Properties:Linkify'));
  const hasLinkifyDomainTextDisplayHintAccess = getIsUngated(gate('CRM:Properties:Linkify:DomainNameTextDisplayHint')) && property.textDisplayHint === 'domain_name';
  const hasLinkifyAccess = hasLinkifyAllPropertiesAccess || hasLinkifyDomainTextDisplayHintAccess;
  if (hasLinkifyAccess && enableAutolinking && typeof displayedValue === 'string' && property.fieldType === 'text') {
    return /*#__PURE__*/_jsx("span", Object.assign({}, dataAttributes, {
      children: /*#__PURE__*/_jsx(AutolinkedText, {
        text: displayedValue
      })
    }));
  }
  return /*#__PURE__*/_jsx("span", Object.assign({}, dataAttributes, {
    children: displayedValue
  }));
};